import { Col, Input, Row } from "reactstrap"
import styles from "./Personal.module.scss"
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown"
import Checkbox from "../../../../../components/common/Checkbox/Checkbox"
import NoProfileImage from "../../../../../assets/images/SellerPortalImages/Settings/no-profile.png"
import Plus from "../../../../../assets/images/SellerPortalImages/Settings/plus.svg"

const Personal = () => {
  return (
    <div className="py-3">
      <div className={styles["heading"]}>Personal Information</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Seller ID</Col>
            <Col xs='12' lg="4">SDHFKJ45</Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Your full name</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Choose from dropdown menu" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Phone number:</Col>
            <Col xs='12' lg="4">
              <Input type="number" placeholder="Enter phone" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Email Address:</Col>
            <Col xs='12' lg="4">
              <Input type="text" placeholder="Enter email" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Gender</Col>
            <Col xs='12' lg="4">
              <div className="border rounded p-2">
                <CustomDropdown title={"Select from dropdown"} muted />
              </div>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Vacation Mode:</Col>
            <Col xs='12' lg="4">
              <div className="d-flex gap-3">
                <div className="d-flex align-items-center gap-1">
                  <span>Yes</span>
                  <Checkbox />
                </div>
                <div className="d-flex align-items-center gap-1">
                  <span>No</span>
                  <Checkbox />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Vacation Period:</Col>
            <Col xs='12' lg="4">
              <Row className="g-0">
                <Col>
                  <div>
                    <Input type="date" />
                  </div>
                </Col>
                <Col xs="1" className="d-flex align-items-center justify-content-center">
                  <b>-</b>
                </Col>
                <Col>
                  <div>
                    <Input type="date" />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>

      <div className={styles["heading"]}>Profile Picture</div>
      <div className="p-2 bg-white">
        <div className="border border-subtle-secondary p-3">
          <Row>
            <Col xs='12' lg='2' className="d-flex flex-column align-items-center gap-2">
              <div className={styles["no-profile-pic"]}>
                <img src={NoProfileImage} alt="" />
                <img src={Plus} alt="" className={styles["plus"]} />
              </div>

              <div className={styles.label}>Add Profile Picture</div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default Personal
